import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PageLoading } from "@workspace/venue-management";

export const Route = createFileRoute("/_auth/_dashboard/$tenant")({
	component: RouteComponent,
	pendingComponent: PageLoading,
	beforeLoad({
		params: { tenant },
		context: {
			tenants: { setTenant },
		},
	}) {
		setTenant(tenant);

		return {
			tenant,
		};
	},
});

function RouteComponent() {
	return <Outlet />;
}
